export default __webpack_public_path__ + "static/media/Lecturer.10eef39a.jpg";